// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ClusterDiscoveryCluster
 */
export interface ClusterDiscoveryCluster {
  /**
   *
   * @type {string}
   * @memberof ClusterDiscoveryCluster
   */
  awsAccountId?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterDiscoveryCluster
   */
  azureSubscriptionId?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterDiscoveryCluster
   */
  cloudProvider?: ClusterDiscoveryClusterCloudProviderEnum;
  /**
   *
   * @type {string}
   * @memberof ClusterDiscoveryCluster
   */
  gcpProjectId?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterDiscoveryCluster
   */
  isolationUnit?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterDiscoveryCluster
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterDiscoveryCluster
   */
  oidcIssuerUrl?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterDiscoveryCluster
   */
  partition?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterDiscoveryCluster
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterDiscoveryCluster
   */
  relation?: ClusterDiscoveryClusterRelationEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof ClusterDiscoveryCluster
   */
  roles?: Array<string>;
}

/**
 * @export
 */
export const ClusterDiscoveryClusterCloudProviderEnum = {
  Aws: 'aws',
  Gcp: 'gcp',
  Azure: 'azure',
} as const;
export type ClusterDiscoveryClusterCloudProviderEnum =
  (typeof ClusterDiscoveryClusterCloudProviderEnum)[keyof typeof ClusterDiscoveryClusterCloudProviderEnum];

/**
 * @export
 */
export const ClusterDiscoveryClusterRelationEnum = {
  Self: 'Self',
  Sibling: 'Sibling',
  Other: 'Other',
} as const;
export type ClusterDiscoveryClusterRelationEnum =
  (typeof ClusterDiscoveryClusterRelationEnum)[keyof typeof ClusterDiscoveryClusterRelationEnum];

/**
 * Check if a given object implements the ClusterDiscoveryCluster interface.
 */
export function instanceOfClusterDiscoveryCluster(
  value: object,
): value is ClusterDiscoveryCluster {
  return true;
}

export function ClusterDiscoveryClusterFromJSON(
  json: any,
): ClusterDiscoveryCluster {
  return ClusterDiscoveryClusterFromJSONTyped(json, false);
}

export function ClusterDiscoveryClusterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClusterDiscoveryCluster {
  if (json == null) {
    return json;
  }
  return {
    awsAccountId:
      json['aws_account_id'] == null ? undefined : json['aws_account_id'],
    azureSubscriptionId:
      json['azure_subscription_id'] == null
        ? undefined
        : json['azure_subscription_id'],
    cloudProvider:
      json['cloud_provider'] == null ? undefined : json['cloud_provider'],
    gcpProjectId:
      json['gcp_project_id'] == null ? undefined : json['gcp_project_id'],
    isolationUnit:
      json['isolation_unit'] == null ? undefined : json['isolation_unit'],
    name: json['name'] == null ? undefined : json['name'],
    oidcIssuerUrl:
      json['oidc_issuer_url'] == null ? undefined : json['oidc_issuer_url'],
    partition: json['partition'] == null ? undefined : json['partition'],
    region: json['region'] == null ? undefined : json['region'],
    relation: json['relation'] == null ? undefined : json['relation'],
    roles: json['roles'] == null ? undefined : json['roles'],
  };
}

export function ClusterDiscoveryClusterToJSON(
  json: any,
): ClusterDiscoveryCluster {
  return ClusterDiscoveryClusterToJSONTyped(json, false);
}

export function ClusterDiscoveryClusterToJSONTyped(
  value?: ClusterDiscoveryCluster | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    aws_account_id: value['awsAccountId'],
    azure_subscription_id: value['azureSubscriptionId'],
    cloud_provider: value['cloudProvider'],
    gcp_project_id: value['gcpProjectId'],
    isolation_unit: value['isolationUnit'],
    name: value['name'],
    oidc_issuer_url: value['oidcIssuerUrl'],
    partition: value['partition'],
    region: value['region'],
    relation: value['relation'],
    roles: value['roles'],
  };
}
